import { useEffect } from "react";
import { OptifundDashboardEndPointLogic } from "../../../../../logic/AssetManagement/overview/OptifundDashboard/OptifundDashboardEndPointLogic";

// Fetches one BQL query for a tab, blocking until `websiteSharedUid` is
// resolved (per the spec's Interaction section). Re-fetches whenever
// websiteSharedUid/queryId/startDate/endDate/brand actually change - there
// is no "skip if we already have any data" check, since that also blocked
// legitimate refetches whenever the user picked a new date range; the
// effect's own dependency array is what prevents redundant refetching on
// unrelated re-renders.
export function useOptifundTabData(
  userToken: any,
  websiteSharedUid: string | null,
  queryId: string,
  setData: (data: any) => void,
  setLoading: (isLoading: boolean) => void,
  startDate?: string,
  endDate?: string,
  brand?: string
) {
  useEffect(() => {
    if (!websiteSharedUid) {
      return;
    }

    setLoading(true);
    OptifundDashboardEndPointLogic.runQuery(
      userToken,
      queryId,
      websiteSharedUid,
      setData,
      startDate,
      endDate,
      brand
    ).finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [websiteSharedUid, queryId, startDate, endDate, brand]);
}
